import React from 'react'
import MainHeader from '../../Components/Headers/MainHeader'
import styles from './AllTickets.module.css'

const AllTickets = () => {
    return (
        <div>
            <MainHeader />
            <div>
                All tickets from users will appear here!
            </div>
        </div>
    )
}

export default AllTickets